import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  /** Canonical path e.g. "/services/sap" — base URL is prepended automatically */
  path?: string;
  /** Absolute URL to an OG image (1200×630). Defaults to site-wide social card. */
  image?: string;
  /** "website" | "article" — defaults to "website" */
  type?: string;
}

const SITE_URL = "https://kibalabs.in";
const DEFAULT_IMAGE = `${SITE_URL}/og-default.png`;

export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
}: SEOProps) {
  const canonical = `${SITE_URL}${path}`;
  const fullTitle = title.includes("KIBA Labs") ? title : `${title} | KIBA Labs`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="KIBA Labs" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
